function Skills() {
    return (
        <div className='py-5' id='skill-section'>
            <div classname="row">
                <h1 className='heading'>My Skills</h1>
                <p className='text-center' style={{ color: "silver", padding: "0px 20px" }}>I specialize in both front-end and back-end development, with expertise in creating responsive user interfaces and building robust server-side solutions. I am proficient in database management and have a strong grasp of various technical skills required for comprehensive software development.</p>
            </div>
            <div className="row mb-3">
                <div className="col">
                    <div className="skills-container">
                        <h6 className="skills">C# </h6>
                        <h6 className="skills-percentage">85%</h6>
                    </div>
                    <div class="progress" role="progressbar" aria-label="Example with label" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                        <div class="progress-bar" style={{ width: "85%" }}></div>
                    </div>
                </div>
                <div className="col">
                    <div className="skills-container">
                        <h6 className="skills">C# .NET CORE</h6>
                        <h6 className="skills-percentage">80%</h6>
                    </div>
                    <div class="progress" role="progressbar" aria-label="Example with label" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                        <div class="progress-bar" style={{ width: "80%" }}></div>
                    </div>
                </div>

            </div>
            <div className="row mb-3">
                <div className="col">
                    <div className="skills-container">
                        <h6 className="skills">Classic ASP</h6>
                        <h6 className="skills-percentage">65%</h6>
                    </div>
                    <div class="progress" role="progressbar" aria-label="Example with label" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                        <div class="progress-bar" style={{ width: "65%" }}></div>
                    </div>
                </div>
                <div className="col">
                    <div className="skills-container">
                        <h6 className="skills">Entity Framwork</h6>
                        <h6 className="skills-percentage">80%</h6>
                    </div>
                    <div class="progress" role="progressbar" aria-label="Example with label" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                        <div class="progress-bar" style={{ width: "80%" }}></div>
                    </div>
                </div>

            </div>
            <div className="row mb-3">
                <div className="col">
                    <div className="skills-container">
                        <h6 className="skills">SQL SERVER</h6>
                        <h6 className="skills-percentage">75%</h6>
                    </div>
                    <div class="progress" role="progressbar" aria-label="Example with label" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                        <div class="progress-bar" style={{ width: "75%" }}></div>
                    </div>
                </div>
                <div className="col">
                    <div className="skills-container">
                        <h6 className="skills">MySQL SERVER</h6>
                        <h6 className="skills-percentage">70%</h6>
                    </div>
                    <div class="progress" role="progressbar" aria-label="Example with label" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                        <div class="progress-bar" style={{ width: "70%" }}></div>
                    </div>
                </div>

            </div>
            <div className="row mb-3">
                <div className="col">
                    <div className="skills-container">
                        <h6 className="skills">HTML</h6>
                        <h6 className="skills-percentage">85%</h6>
                    </div>
                    <div class="progress" role="progressbar" aria-label="Example with label" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                        <div class="progress-bar" style={{ width: "85%" }}></div>
                    </div>
                </div>
                <div className="col">
                    <div className="skills-container">
                        <h6 className="skills">CSS</h6>
                        <h6 className="skills-percentage">85%</h6>
                    </div>
                    <div class="progress" role="progressbar" aria-label="Example with label" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                        <div class="progress-bar" style={{ width: "85%" }}></div>
                    </div>
                </div>

            </div>
            <div className="row mb-3">
                <div className="col">
                    <div className="skills-container">
                        <h6 className="skills">JAVASCRIPT</h6>
                        <h6 className="skills-percentage">80%</h6>
                    </div>
                    <div class="progress" role="progressbar" aria-label="Example with label" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                        <div class="progress-bar" style={{ width: "80%" }}></div>
                    </div>
                </div>
                <div className="col">
                    <div className="skills-container">
                        <h6 className="skills">JQUERY</h6>
                        <h6 className="skills-percentage">80%</h6>
                    </div>
                    <div class="progress" role="progressbar" aria-label="Example with label" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                        <div class="progress-bar" style={{ width: "80%" }}></div>
                    </div>
                </div>

            </div>
            <div className="row mb-3">
                <div className="col">
                    <div className="skills-container">
                        <h6 className="skills">BOOTSTRAP</h6>
                        <h6 className="skills-percentage">90%</h6>
                    </div>
                    <div class="progress" role="progressbar" aria-label="Example with label" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                        <div class="progress-bar" style={{ width: "90%" }}></div>
                    </div>
                </div>
                <div className="col">
                    <div className="skills-container">
                        <h6 className="skills">AMAZONE S3</h6>
                        <h6 className="skills-percentage">65%</h6>
                    </div>
                    <div class="progress" role="progressbar" aria-label="Example with label" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                        <div class="progress-bar" style={{ width: "65%" }}></div>
                    </div>
                </div>

            </div>
            <div className="row mb-3">
                <div className="col">
                    <div className="skills-container">
                        <h6 className="skills">REACT</h6>
                        <h6 className="skills-percentage">70%</h6>
                    </div>
                    <div class="progress" role="progressbar" aria-label="Example with label" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                        <div class="progress-bar" style={{ width: "70%" }}></div>
                    </div>
                </div>
                <div className="col">
                    <div className="skills-container">
                        <h6 className="skills">WEB API</h6>
                        <h6 className="skills-percentage">80%</h6>
                    </div>
                    <div class="progress" role="progressbar" aria-label="Example with label" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                        <div class="progress-bar" style={{ width: "80%" }}></div>
                    </div>
                </div>

            </div>
             <div className="row mb-3">
                <div className="col">
                    <div className="skills-container">
                        <h6 className="skills">REACT NATIVE</h6>
                        <h6 className="skills-percentage">60%</h6>
                    </div>
                    <div class="progress" role="progressbar" aria-label="Example with label" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                        <div class="progress-bar" style={{ width: "60%" }}></div>
                    </div>
                </div>
                <div className="col">
                    <div className="skills-container">
                        <h6 className="skills">IIS SERVER</h6>
                        <h6 className="skills-percentage">95%</h6>
                    </div>
                    <div class="progress" role="progressbar" aria-label="Example with label" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
                        <div class="progress-bar" style={{ width: "95%" }}></div>
                    </div>
                </div>

            </div>
        </div>
    );
}
export default Skills;